( () => {
    var b = "dual-listbox"
      , v = "dual-listbox__container"
      , p = "dual-listbox__available"
      , E = "dual-listbox__selected"
      , r = "dual-listbox__title"
      , ra = "dual-listbox__title--available"
      , rs = "dual-listbox__title--selected"
      , c = "dual-listbox__item"
      , m = "dual-listbox__buttons"
      , md = "dual-lisbox__buttons--disabled"
      , f = "dual-listbox__button"
      , u = "dual-listbox__search"
      , a = "dual-listbox__item--selected"
      , pr = "dual-listbox__parents"
      , _ = "up"
      , L = "down"
      , d = class {
        constructor(t, e={}, cb={}) {
            this.setDefaults(),
            this.selected = [],
            this.available = [],
            d.isDomElement(t) ? this.select = t : this.select = document.querySelector(t),
            this._initOptions(e, cb),
            this._initReusableElements(),
            this._splitOptions(this.select.options),
            e.options !== void 0 && this._splitOptions(e.options),
            this._buildDualListbox(this.select.parentNode),
            this._addActions(),
            this.sortable && this._initializeSortButtons(),
            this.redraw()
        }
        setDefaults() {
            this.addEvent = null,
            this.removeEvent = null,
            this.currentParents = null,
            this.availableTitle = "Available options",
            this.selectedTitle = "Selected options",
            this.showAddButton = !0,
            this.addButtonText = "add",
            this.showRemoveButton = !0,
            this.removeButtonText = "remove",
            this.showSearch = !1,
            this.showAddAllButton = !0,
            this.addAllButtonText = "add all",
            this.showRemoveAllButton = !0,
            this.removeAllButtonText = "remove all",
            this.searchPlaceholder = "Search...",
            this.sortable = !1,
            this.upButtonText = "up",
            this.downButtonText = "down",
            this.availableTree = false,
            this.selectedTree = false
        }
        addEventListener(t, e) {
            this.dualListbox.addEventListener(t, e)
        }
        addSelected(t) {
            if (!this.selectedTree) {
                if (t.dataset.parents 
                    && JSON.stringify(this.currentParents) === JSON.stringify(t.dataset.parents) 
                    && this.currentParents !== null 
                    && !this.checkExistSelected(t.dataset.id)) {
                        this.selected.push(t)
                    }
            } else {
                this.selected.push(t)
            }
            let e = this.available.indexOf(t);
            e > -1 && (this.available.splice(e, 1),
            t.classList.remove(a),
            this._selectOption(t.dataset.id),
            this.redraw(),
            setTimeout( () => {
                let s = document.createEvent("HTMLEvents");
                s.initEvent("added", !1, !0),
                s.addedElement = t,
                this.dualListbox.dispatchEvent(s)
            }
            , 0))
        }
        addMultipleSelectd(tl) {
            tl.forEach(it => {
                this.available.splice(this.available.indexOf(it), 1);
                if (!this.selectedTree) {
                    if (it.dataset.parents 
                        && JSON.stringify(this.currentParents) === JSON.stringify(it.dataset.parents)
                        && this.currentParents !== null
                        && !this.checkExistSelected(it.dataset.id)) {
                        this.selected.push(it);
                    };
                } else {
                    this.selected.push(it);
                }
                it.classList.remove(a),
                this._selectOption(it.dataset.id);
            });
            this.redraw();
        }
        redraw() {
            this.updateAvailableListbox(),
            this.updateSelectedListbox()
        }
        removeSelected(t) {
            if (!this.availableTree) {
                if (t.dataset.parents 
                    && JSON.stringify(this.currentParents) === JSON.stringify(t.dataset.parents) 
                    && this.currentParents !== null 
                    && !this.checkExistAvailable(t.dataset.id)) {
                        this.available.push(t)
                    }
            } else {
                this.available.push(t)
            }
            let e = this.selected.indexOf(t);
            e > -1 && (this.selected.splice(e, 1),
            t.classList.remove(a),
            this._deselectOption(t.dataset.id),
            this.redraw(),
            setTimeout( () => {
                let s = document.createEvent("HTMLEvents");
                s.initEvent("removed", !1, !0),
                s.removedElement = t,
                this.dualListbox.dispatchEvent(s)
            }
            , 0))
        }
        removeMultipleSelected(tl) {
            tl.forEach(it => {
                this.selected.splice(this.selected.indexOf(it), 1);
                if (!this.availableTree) {
                    if (it.dataset.parents 
                        && JSON.stringify(this.currentParents) === JSON.stringify(it.dataset.parents)
                        && this.currentParents !== null
                        && !this.checkExistAvailable(it.dataset.id)) {
                        this.available.push(it);
                    };
                } else {
                    this.available.push(it);
                }
                it.classList.remove(a);
                this._deselectOption(it.dataset.id);
            });
        
            this.redraw();
        }
        checkExistAvailable(a) {
            return this.available.some(e => {return e.dataset.id === a})
        }
        checkExistSelected(a) {
            return this.selected.some(e => {return e.dataset.id === a})
        }
        searchLists(t, e) {
            let s = e.querySelectorAll(`.${c}`)
              , i = t.toLowerCase();
            let countNoneEl = 0;
            for (let l = 0; l < s.length; l++) {
                let n = s[l];
                if (n.textContent.toLowerCase().indexOf(i) === -1) {
                    countNoneEl += 1;
                    n.style.display = "none"
                } else {
                    n.style.display = "list-item"
                }
            }
            const isAvailableParent = e.closest(`.${p}`) ? true : false;
            switch (isAvailableParent) {
                case true:
                    if (countNoneEl === s.length) {
                        this.add_all_button.classList.add(md);
                    } else {
                        this.add_all_button.classList.remove(md);
                    }
                    break;
                case false:
                    if (countNoneEl === s.length) {
                        this.remove_all_button.classList.add(md)
                    } else {
                        this.remove_all_button.classList.remove(md)
                    }
                    break;
                default:
                    break;
            }
            this.add_button.classList.add(md);
            this.remove_button.classList.add(md);
            let currentItemSelected = this.dualListbox.querySelectorAll(`.${a}`);
            if (currentItemSelected.length !== 0) {
                for (let index = 0; index < currentItemSelected.length; index++) {
                    const element = currentItemSelected[index];
                    element.classList.remove(a);
                }
            }
        }
        changeOptions(o) {
            this.available = [];
            o = this._removeSelectedOptions(o);
            o.forEach(option => {
                const listItem = this._createListItem(option);
                this.available.push(listItem);
            });
            this.updateAvailableListbox();
            this.onAdd({
                availableList: this.available.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}}),
                selectedList: this.selected.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}})
            });
            if (this.available.length === 0) {
                this.add_all_button.classList.add(md);
                this.add_button.classList.add(md);
            } else {
                this.add_all_button.classList.remove(md);
                const e = this.dualListbox.querySelectorAll(`.${a}`);
                if (e.length === 0)
                this.add_button.classList.add(md);
            }
        }
        changeSelectedOptions(o) {
            this.selected = [],
            o.forEach(option => {
                const listItem = this._createListItem(option);
                this.selected.push(listItem);
            })
            this.updateSelectedListbox()
            this.onRemove({
                availableList: this.available.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}}),
                selectedList: this.selected.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}})
            });
            if (this.selected.length === 0) {
                this.remove_all_button.classList.add(md);
                this.remove_button.classList.add(md);
            } else {
                this.remove_all_button.classList.remove(md);
                const e = this.dualListbox.querySelectorAll(`.${a}`);
                if (e.length === 0)
                this.remove_button.classList.add(md);
            }
        }
        updateAvailableListbox() {
            if (this.available.every(e => JSON.parse(e.dataset.parents) !== null) && this.availableTree) {
                this.availableList.innerHTML = "";
                this.available.forEach(option => {
                    option.innerHTML = `<span>${option.dataset.text} (${option.dataset.id})</span>`
                    const parents = JSON.parse(option.dataset.parents);
                    const container = this._ensureParent(parents, this.availableList);
                    container.appendChild(option);
                });
            } else {
                this.available.forEach(option => {
                    option.innerHTML = `<span>${option.dataset.text} (${option.dataset.suffix})</span>`
                })
                this._updateListbox(this.availableList, this.available)
            }

            this._updateTitle();
        }
        updateSelectedListbox() {
            if (this.selected.every(e => JSON.parse(e.dataset.parents) !== null) && this.selectedTree) {
                this.selectedList.innerHTML = "";
                this.selected.forEach(option => {
                    option.innerHTML = `<span>${option.dataset.text} (${option.dataset.id})</span>`
                    const parents = JSON.parse(option.dataset.parents);
                    const container = this._ensureParent(parents, this.selectedList);
                    container.appendChild(option);
                });
            } else {
                this.selected.forEach(option => {
                    option.innerHTML = `<span>${option.dataset.text} (${option.dataset.suffix})</span>`
                })
                this._updateListbox(this.selectedList, this.selected)
            }

            this._updateTitle();
        }
        _updateTitle() {
            const availableTitle = this.dualListbox.querySelector(`.${ra}`);
            const selectedTitle = this.dualListbox.querySelector(`.${rs}`);
            availableTitle.innerText = this.availableTitle + ` (${this.available.length})`;
            selectedTitle.innerText = this.selectedTitle + ` (${this.selected.length})`    
        }
        _removeSelectedOptions(o) {
            const currentSelected = this.selected.map(item => item.dataset.id);
            return o.filter((e) => {
                return !currentSelected.includes(e.value)
            })
        }
        _actionAllSelected(t) {
            t.preventDefault()
            this.available.filter(s => s.style.display !== "none").forEach(s => this.addSelected(s))
        }
        _updateListbox(t, e) {
            for (; t.firstChild; )
                t.removeChild(t.firstChild);
            for (let s = 0; s < e.length; s++) {
                let i = e[s];
                t.appendChild(i)
            }
        }
        _ensureParent(parents, container) {
            let currentContainer = container
            parents.forEach(parentData => {
                let parent = currentContainer.querySelector(`[data-parent-id="${parentData.key}-${parentData.value}"]`)
                if (!parent) {
                    parent = document.createElement("li")
                    parent.classList.add(`level-${parentData.level}`)
                    parent.classList.add(pr)
                    parent.dataset.parentId = `${parentData.key}-${parentData.value}`
                    const parentName = document.createElement("strong")
                    parentName.textContent = parentData.name
                    parent.appendChild(parentName)
                    const subList = document.createElement("ul")
                    parent.appendChild(subList)
                    currentContainer.appendChild(parent)
                }
                currentContainer = parent.querySelector("ul")
            });
            return currentContainer;
        }
        _actionItemSelected(t) {
            t.preventDefault();
            let e = this.dualListbox.querySelectorAll(`.${a}`);
            e && e.length === 1 ? this.addSelected(e[0]) : this.addMultipleSelectd(e)
        }
        _actionAllDeselected(t) {
            t.preventDefault(),
            this.selected.filter(s => s.style.display !== "none").forEach(s => this.removeSelected(s))
        }
        _actionItemDeselected(t) {
            t.preventDefault();
            let e = this.dualListbox.querySelectorAll(`.${a}`);
            e && e.length === 1 ? this.removeSelected(e[0]) : this.removeMultipleSelected(e)
        }
        _actionItemDoubleClick(t, e=null) {
            e && (e.preventDefault(),
            e.stopPropagation());
            const isAvailableParent = t.closest(`.${p}`) ? true : false;
            isAvailableParent ? this.add_button.classList.add(md) : this.remove_button.classList.add(md);
            if (!this.availableTree && this.available.length > 0 && this.available.every(e => JSON.parse(e.dataset.parents) !== null)) {
                this.currentParents = this.available[0].dataset.parents
            }
            this.selected.indexOf(t) > -1 ? this.removeSelected(t) : this.addSelected(t);
            switch (isAvailableParent) {
                case true:
                    if (this.available.length === 0) {
                        this.add_all_button.classList.add(md)
                    } else {
                        this.add_all_button.classList.remove(md)
                    }
                    this.remove_all_button.classList.remove(md)
                    this.onAdd({
                        availableList: this.available.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}}),
                        selectedList: this.selected.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}})
                    });
                    break;
                case false:
                    if (this.selected.length === 0) {
                        this.remove_all_button.classList.add(md)
                    } else {
                        this.remove_all_button.classList.remove(md)
                    }
                    this.add_all_button.classList.remove(md)
                    this.onRemove({
                        availableList: this.available.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}}),
                        selectedList: this.selected.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}})
                    });
                    break;
                default:
                    break;
            }
        }
        _actionItemClick(t, e, s=null) {
            s && s.preventDefault();
            if (s.ctrlKey || s.metaKey) {
                const csl = this.dualListbox.querySelectorAll(`.${a}`);
                const isAvailableParent = t.closest(`.${p}`);
                if (csl[0]) {
                    const previousElCol = csl[0].closest(`.${p}`);
                    if (previousElCol !== isAvailableParent) {
                        for (let l = 0; l < csl.length; l++) {
                            let n = csl[l];
                            n.classList.remove(a);
                        }
                        previousElCol ? this.add_button.classList.add(md) : this.remove_button.classList.add(md);
                    }
                }
                isAvailableParent ? this.add_button.classList.remove(md) : this.remove_button.classList.remove(md);
                t.classList.contains(a) ? t.classList.remove(a) : t.classList.add(a);
            } else {
                let i = e.querySelectorAll(`.${c}`);
                const isAvailableParent = t.closest(`.${p}`);
                for (let l = 0; l < i.length; l++) {
                    let n = i[l];
                    n.classList.remove(a);
                    isAvailableParent ? this.add_button.classList.add(md) : this.remove_button.classList.add(md);
                }
                t.classList.add(a);
                isAvailableParent ? this.add_button.classList.remove(md) : this.remove_button.classList.remove(md);
            }
        }
        _addActions() {
            this._addButtonActions();
            if (this.showSearch !== false) {
                this._addSearchActions()
            }
        }
        _addButtonActions() {
            this.add_all_button.addEventListener("click", (t) => {
                if (!this.availableTree && this.available.length > 0 && this.available.every(e => JSON.parse(e.dataset.parents) !== null)) {
                    this.currentParents = this.available[0].dataset.parents
                }
                this._actionAllSelected(t)
                if (typeof this.onAddAll === "function") {
                    this.onAddAll({
                        availableList: this.available.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}}),
                        selectedList: this.selected.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}})
                    });
                }
                this.add_all_button.classList.add(md)
                this.add_button.classList.add(md)
                this.remove_all_button.classList.remove(md)
            }),
            this.add_button.addEventListener("click", (t) => {
                if (!this.availableTree && this.available.length > 0 && this.available.every(e => JSON.parse(e.dataset.parents) !== null)) {
                    this.currentParents = this.available[0].dataset.parents
                }
                this._actionItemSelected(t);
                if (typeof this.onAdd === "function") {
                    this.onAdd({
                        availableList: this.available.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}}),
                        selectedList: this.selected.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}})
                    });
                }
                this.add_button.classList.add(md);
                if (this.available.length === 0) {
                    this.add_all_button.classList.add(md)
                }
                this.remove_all_button.classList.remove(md)
                const checkRemoveBtnDisabled = this.remove_button.classList.contains(md);
                !checkRemoveBtnDisabled ? this.remove_button.classList.add(md) : null;
            }),
            this.remove_button.addEventListener("click", (t) => {
                this._actionItemDeselected(t);
                if (typeof this.onRemove === "function") {
                    this.onRemove({
                        availableList: this.available.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}}),
                        selectedList: this.selected.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}})
                    });
                }
                this.remove_button.classList.add(md)
                if (this.selected.length === 0) {
                    this.remove_all_button.classList.add(md)
                }
                const checkAddBtnDisabled = this.add_button.classList.contains(md);
                !checkAddBtnDisabled ? this.add_button.classList.add(md) : null;
            }),
            this.remove_all_button.addEventListener("click", (t) => {
                this._actionAllDeselected(t);
                if (typeof this.onRemoveAll === "function") {
                    this.onRemoveAll({
                        availableList: this.available.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}}),
                        selectedList: this.selected.map(item => {return {value: item.dataset.id, parents: item.dataset.parents, text: item.dataset.text}})
                    });
                }
                this.remove_all_button.classList.add(md)
                this.remove_button.classList.add(md)
                this.add_all_button.classList.remove(md)
            })
        }
        _addClickActions(t) {
            return t.addEventListener("dblclick", e => this._actionItemDoubleClick(t, e)),
            t.addEventListener("click", e => this._actionItemClick(t, this.dualListbox, e)),
            t
        }
        _addSearchActions() {
            this.search_left.addEventListener("change", t => this.searchLists(t.target.value, this.availableList)),
            this.search_left.addEventListener("keyup", t => this.searchLists(t.target.value, this.availableList)),
            this.search_right.addEventListener("change", t => this.searchLists(t.target.value, this.selectedList)),
            this.search_right.addEventListener("keyup", t => this.searchLists(t.target.value, this.selectedList))
        }
        _buildDualListbox(t) {
            this.select.style.display = "none",
            this.dualListBoxContainer.appendChild(this._createList(this.search_left, this.availableListTitle, this.availableList)),
            this.dualListBoxContainer.appendChild(this.buttons),
            this.dualListBoxContainer.appendChild(this._createList(this.search_right, this.selectedListTitle, this.selectedList)),
            this.dualListbox.appendChild(this.dualListBoxContainer),
            t.insertBefore(this.dualListbox, this.select)
        }
        _createList(t, e, s) {
            let i = document.createElement("div");
            if (e instanceof Node) {
                i.appendChild(e);
            }
            if (t instanceof Node) {
                i.appendChild(t);
            }
            if (s instanceof Node) {
                i.appendChild(s);
            }
            return i;
        }
        _createButtons() {
            this.buttons = document.createElement("div"),
            this.buttons.classList.add(m),
            this.add_all_button = document.createElement("button"),
            this.add_all_button.innerHTML = this.addAllButtonText,
            this.add_button = document.createElement("button"),
            this.add_button.innerHTML = this.addButtonText;
            if (this.available.length === 0) {
                this.add_all_button.classList.add(md)
                this.add_button.classList.add(md)
            }
            this.remove_button = document.createElement("button"),
            this.remove_button.innerHTML = this.removeButtonText,
            this.remove_all_button = document.createElement("button"),
            this.remove_all_button.innerHTML = this.removeAllButtonText;
            if (this.selected.length === 0) {
                this.remove_all_button.classList.add(md)
                this.remove_button.classList.add(md)
            }
            let t = {
                showAddAllButton: this.add_all_button,
                showAddButton: this.add_button,
                showRemoveButton: this.remove_button,
                showRemoveAllButton: this.remove_all_button
            };
            for (let e in t)
                if (e) {
                    let s = this[e]
                      , i = t[e];
                    i.setAttribute("type", "button"),
                    i.classList.add(f),
                    s && this.buttons.appendChild(i)
                }
        }
        _createListItem(t) {
            const item = document.createElement("li");
            const text = document.createElement("span");
            item.classList.add(c);
            item.appendChild(text);
            text.innerHTML = t.suffix ? t.text + ' ' + t.suffix : t.text;
            item.dataset.id = t.value;
            item.dataset.text = t.text;
            item.dataset.suffix = t.suffix ?? '';
            item.dataset.parents = t.parents ? JSON.stringify(t.parents) : null;
            this._addClickActions(item);
            return item;
        }
        _createSearchLeft() {
            this.search_left = document.createElement("input"),
            this.search_left.classList.add(u),
            this.search_left.placeholder = this.searchPlaceholder
        }
        _createSearchRight() {
            this.search_right = document.createElement("input"),
            this.search_right.classList.add(u),
            this.search_right.placeholder = this.searchPlaceholder
        }
        _deselectOption(t) {
            let e = this.select.options;
            for (let s = 0; s < e.length; s++) {
                let i = e[s];
                i.value === t && (i.selected = !1,
                i.removeAttribute("selected"))
            }
            this.removeEvent && this.removeEvent(t)
        }
        _initOptions(t, cb) {
            for (let e in t)
                t.hasOwnProperty(e) && (this[e] = t[e])

            // Default callbacks
            this.onAdd = cb.onAdd || null;
            this.onAddAll = cb.onAddAll || null;
            this.onRemove = cb.onRemove || null;
            this.onRemoveAll = cb.onRemoveAll || null;
        }
        _initReusableElements() {
            this.dualListbox = document.createElement("div"),
            this.dualListbox.classList.add(b),
            this.select.id && this.dualListbox.classList.add(this.select.id),
            this.dualListBoxContainer = document.createElement("div"),
            this.dualListBoxContainer.classList.add(v),
            this.availableList = document.createElement("ul"),
            this.availableList.classList.add(p),
            this.selectedList = document.createElement("ul"),
            this.selectedList.classList.add(E),
            this.availableListTitle = document.createElement("div"),
            this.availableListTitle.classList.add(r),
            this.availableListTitle.classList.add(ra),
            this.availableListTitle.innerText = this.availableTitle,
            this.selectedListTitle = document.createElement("div"),
            this.selectedListTitle.classList.add(r),
            this.selectedListTitle.classList.add(rs),
            this.selectedListTitle.innerText = this.selectedTitle,
            this._createButtons();
            if (this.showSearch !== false) {
                this._createSearchLeft();
                this._createSearchRight();
            }
        }
        _selectOption(t) {
            let e = this.select.options;
            for (let s = 0; s < e.length; s++) {
                let i = e[s];
                i.value === t && (i.selected = !0,
                i.setAttribute("selected", ""))
            }
            this.addEvent && this.addEvent(t)
        }
        _splitOptions(t) {
            for (let e = 0; e < t.length; e++) {
                let s = t[e];
                d.isDomElement(s) ? this._addOption({
                    text: s.innerHTML,
                    value: s.value,
                    selected: s.attributes.selected,
                    parents: s.parents ? JSON.stringify(s.parents) : null
                }) : this._addOption(s)
            }
        }
        _addOption(t) {
            let e = this._createListItem(t);
            t.selected ? this.selected.push(e) : this.available.push(e)
        }
        _initializeSortButtons() {
            let t = document.createElement("button");
            t.classList.add("dual-listbox__button"),
            t.innerHTML = this.upButtonText,
            t.addEventListener("click", i => this._onSortButtonClick(i, _));
            let e = document.createElement("button");
            e.classList.add("dual-listbox__button"),
            e.innerHTML = this.downButtonText,
            e.addEventListener("click", i => this._onSortButtonClick(i, L));
            let s = document.createElement("div");
            s.classList.add("dual-listbox__buttons"),
            s.appendChild(t),
            s.appendChild(e),
            this.dualListBoxContainer.appendChild(s)
        }
        _onSortButtonClick(t, e) {
            t.preventDefault();
            let[s,i] = this._findSelected(e);
            s !== i && (this._sortUnderlyingSelectOptions(s, i),
            this._sortSelected(s, i),
            this.redraw())
        }
        _findSelected(t) {
            let e = this.selected.findIndex(i => i.classList.contains("dual-listbox__item--selected"))
              , s = e;
            return _ === t && e > 0 ? s -= 1 : L === t && e < this.selected.length - 1 && (s += 1),
            [e, s]
        }
        _sortUnderlyingSelectOptions(t, e) {
            let s = this.selected[t].getAttribute("data-id")
              , i = this.selected[e].getAttribute("data-id")
              , l = [...this.select.children].findIndex(o => o.value === s)
              , n = [...this.select.children].findIndex(o => o.value === i)
              , h = this.select.children[l];
            h.remove(),
            this.select.insertBefore(h, this.select.children[n])
        }
        _sortSelected(t, e) {
            let s = this.selected[t];
            this.selected.splice(t, 1),
            this.selected.splice(e, 0, s)
        }
        static isDomElement(t) {
            return typeof HTMLElement == "object" ? t instanceof HTMLElement : t && typeof t == "object" && t !== null && t.nodeType === 1 && typeof t.nodeName == "string"
        }
    }
    ;
    window.DualListbox = d;
    var x = d;
}
)();
//# sourceMappingURL=dual-listbox.js.map
